import React, { useEffect, useState } from 'react'
import TicketRequestService from 'services/ticket-request'
import ReactApexChart from 'react-apexcharts'
import { Col, Form, Row } from 'react-bootstrap';

import "./style.scss"

export default function ({
  setTotalTickets
}) {
  const chartPieConfig = {
    series: [],
    options: {
      chart: {
        type: 'pie',
      },
      legend: {
        position: 'bottom'
      },
      labels: [],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 450
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
  };

  const chartBarConfig = {
    series: [{
      data: []
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: 'top', // top, center, bottom
          }
        }
      },
      dataLabels: {
        formatter: (val, opt) => {
          //console.log({val, opt})
        }
      },
      xaxis: {
        categories: [],
        axisTicks: {
          show: false
        },
        crosshairs: {
          fill: {
            type: 'gradient',
            gradient: {
              colorFrom: '#D8E3F0',
              colorTo: '#BED1E6',
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            }
          }
        },
        tooltip: {
          enabled: true,
        }
      },
      tooltip: {
        theme: 'dark',
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function () {
              return ''
            }
          }
        }
      }
    },
  }


  const [categoriesChartData, setCategoriesChartData] = useState({ ...chartPieConfig })
  const [prioritiesChartData, setPrioritiesChartData] = useState({ ...chartPieConfig })
  const [timeChartData, setTimeChartData] = useState({ ...chartPieConfig })

  const [currentBarChart, setCurrentBarChart] = useState("day")
  const [dateDayChartData, setDateDayChartData] = useState({ ...chartBarConfig })
  const [dateWeekChartData, setDateWeekChartData] = useState({ ...chartBarConfig })
  const [dateMonthChartData, setDateMonthChartData] = useState({ ...chartBarConfig })


  const chartCategoryData = async () => {
    const response = await TicketRequestService.getCountTicketsCategories()
    const { labels, series, total } = response.data
    
    setTotalTickets(total)
    setCategoriesChartData(prev => {
      return {
        ...prev,
        series: series,
        options: {
          ...prev.options,
          labels: labels
        }
      }
    })
  }

  const chartPriorityData = async () => {
    const response = await TicketRequestService.getCountTicketsPriorities()
    const { labels, series } = response.data
    setPrioritiesChartData(prev => {
      return {
        ...prev,
        series: series,
        options: {
          ...prev.options,
          labels: labels
        }
      }
    })
  }

  const chartTimeData = async () => {
    const response = await TicketRequestService.getCountTicketsTime()
    const { labels, series } = response.data
    setTimeChartData(prev => {
      return {
        ...prev,
        series: series,
        options: {
          ...prev.options,
          labels: labels
        }
      }
    })
  }

  const chartDateData = async () => {
    const response = await TicketRequestService.getCountTicketsDate()
    const { tickets_by_day, tickets_by_week, tickets_by_month } = response.data
    setDateDayChartData(prev => {
      return {
        ...prev,
        series: [{ data: tickets_by_day.series }],
        options: {
          ...prev.options,
          xaxis: {

            categories: tickets_by_day.labels
          }
        }
      }
    })

    setDateWeekChartData(prev => {
      return {
        ...prev,
        series: [{ data: tickets_by_week.series }],
        options: {
          ...prev.options,
          xaxis: {
            categories: tickets_by_week.labels
          }
        }
      }
    })

    setDateMonthChartData(prev => {
      return {
        ...prev,
        series: [{ data: tickets_by_month.series }],
        options: {
          ...prev.options,
          xaxis: {
            categories: tickets_by_month.labels
          }
        }
      }
    })
  }

  const getTotal = async () => {
    const response = await TicketRequestService.getTotal()
  }

  useEffect(() => {
    try {
      //getTotal()
      chartCategoryData()
      chartPriorityData()
      chartTimeData()
      chartDateData()
    } catch (err) {
      console.error(err)
    } finally {

    }
  }, [])

  return (
    <div className='container-fluid'>
      <Row>
        <Col md="12" style={{ borderBottom: "1px solid #eee", marginBottom: "1rem" }}>
          <div className='div-pie-charts mb-5'>
            <div className='chart-item'>
              <span className='h4'>Por categoria</span>
              <hr />
              <ReactApexChart options={categoriesChartData.options} series={categoriesChartData.series} type="pie" />
            </div>
            <div className='chart-item'>
              <span className='h4'>Por prioridade</span>
              <hr />
              <ReactApexChart options={prioritiesChartData.options} series={prioritiesChartData.series} type="pie" />
            </div>
            <div className='chart-item'>
              <span className='h4'>Por tempo de atendimento</span>
              <hr />
              <ReactApexChart options={timeChartData.options} series={timeChartData.series} type="pie" />
            </div>
          </div>
        </Col>
        <Col md="12">
          <div className='d-flex align-items-center'>
            <span className='h4 mr-3'>Por categoria</span>
            <Form.Group style={{ margin: "10px 0" }} value={currentBarChart} onChange={e => setCurrentBarChart(e.target.value)}>
              <Form.Control size='sm' as="select">
                <option value="day">Por Dia</option>
                <option value="week">Por Samana</option>
                <option value="month">Por Mês</option>
              </Form.Control>
            </Form.Group>
          </div>
          <hr />
          {currentBarChart == "day" && <ReactApexChart options={dateDayChartData.options} series={dateDayChartData.series} type="bar" height={350} />}
          {currentBarChart == "week" && <ReactApexChart options={dateWeekChartData.options} series={dateWeekChartData.series} type="bar" height={350} />}
          {currentBarChart == "month" && <ReactApexChart options={dateMonthChartData.options} series={dateMonthChartData.series} type="bar" height={350} />}
        </Col>
      </Row>
    </div>
  )
}
